// extracted by mini-css-extract-plugin
export default {"list":"AuthInfoSignDocuments_list__33H8b","info":"AuthInfoSignDocuments_info__2Fh5c","button":"AuthInfoSignDocuments_button__4oq55"};